import { useEffect, useState } from 'react';
import { navLinks, siteName } from '@/mocks/comicData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const light = !scrolled && !open;

  const linkClass = (): string =>
    `whitespace-nowrap text-sm transition-colors duration-200 ${
      light ? 'text-background-100 hover:text-white' : 'text-foreground-700 hover:text-primary-600'
    }`;

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'border-b border-background-200/70 bg-background-50/90 shadow-sm backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-[72px] md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full ${
              light ? 'bg-background-100/20 text-background-50 ring-1 ring-background-100/40' : 'bg-primary-500 text-background-50'
            }`}
          >
            <i className="ri-store-2-line text-lg" />
          </span>
          <span
            className={`font-label text-base font-bold tracking-wide ${
              light ? 'text-white' : 'text-foreground-950'
            }`}
          >
            {siteName}
          </span>
        </a>

        <div className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} className={linkClass()}>
              {link.label}
            </a>
          ))}
          <a
            href="#updates"
            className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-colors ${
              light
                ? 'bg-background-50 text-primary-700 hover:bg-white'
                : 'bg-primary-500 text-background-50 hover:bg-primary-600'
            }`}
          >
            追更漫画
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
            light ? 'text-white' : 'text-foreground-900'
          }`}
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}